import { useEffect } from "react";
import Lenis from "lenis";
import "@/App.css";
import { setLenis } from "@/lib/smooth";
import { Grain } from "@/components/Grain";
import { Nav } from "@/components/Nav";
import { Hero } from "@/components/Hero";
import { Work } from "@/components/Work";
import { MarqueeDivider } from "@/components/Marquee";
import { About } from "@/components/About";
import { Statement } from "@/components/Statement";
import { Resume } from "@/components/Resume";
import { Docs } from "@/components/Docs";
import { Contact } from "@/components/Contact";

function App() {
    useEffect(() => {
        const lenis = new Lenis({ lerp: 0.08 });
        setLenis(lenis);
        let frame;
        const loop = (time) => {
            lenis.raf(time);
            frame = requestAnimationFrame(loop);
        };
        frame = requestAnimationFrame(loop);
        return () => {
            cancelAnimationFrame(frame);
            lenis.destroy();
            setLenis(null);
        };
    }, []);

    return (
        <div className="App bg-[#050505] text-white">
            <Grain />
            <Nav />
            <main>
                <Hero />
                <Work />
                <MarqueeDivider />
                <About />
                <Statement />
                <Resume />
                <Docs />
                <Contact />
            </main>
        </div>
    );
}

export default App;
